var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
var TaskBoxService = /** @class */ (function () {
    function TaskBoxService() {
    }
    /**
     * 查询
     */
    TaskBoxService.prototype.query = function (page) {
        return this.netService.send({
            server: domainService.taskBoxController.query,
            page: page
        });
    };
    __decorate([
        Inject(NetService)
    ], TaskBoxService.prototype, "netService", void 0);
    return TaskBoxService;
}());
export { TaskBoxService };
